"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/user-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Fuser-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserServiceClient = exports.getVerificationMethodResponseMethodToJSON = exports.getVerificationMethodResponseMethodFromJSON = exports.GetQuotasResponse = exports.GetQuotasRequest = exports.GetProfilePicturesResponse = exports.GetProfilePicturesRequest = exports.OffboardResponse = exports.OffboardRequest = exports.OnboardResponse = exports.OnboardRequest = exports.VerifyUserResponse = exports.VerifyUserRequest = exports.GetVerificationMethodResponse = exports.GetVerificationMethodRequest = exports.RemoveProfilePictureResponse = exports.RemoveProfilePictureRequest = exports.SetProfilePictureResponse = exports.SetProfilePictureRequest = exports.UpdateShippingAddressResponse = exports.UpdateShippingAddressRequest = exports.UpdateUserResponse = exports.CreateUserResponse = exports.CreateUserRequest = exports.GetUserResponse = exports.GetUserRequest = exports.GetVerificationMethodResponseMethod = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const address_1 = require("../common/address");
const device_token_1 = require("../common/device-token");
const kyc_1 = require("../common/kyc");
const kyc_error_1 = require("../common/kyc-error");
const token_1 = require("../common/token");
const quota_state_1 = require("../quota/quota-state");
const user_1 = require("./user");
const user_update_request_1 = require("./user-update-request");
const protobufPackage = 'com.step.user.proto';
var GetVerificationMethodResponseMethod;
(function (GetVerificationMethodResponseMethod) {
    GetVerificationMethodResponseMethod["VERIFICATION_METHOD_INVALID"] = "VERIFICATION_METHOD_INVALID";
    GetVerificationMethodResponseMethod["USE_DOB"] = "USE_DOB";
    GetVerificationMethodResponseMethod["USE_SSN"] = "USE_SSN";
    GetVerificationMethodResponseMethod["UNRECOGNIZED"] = "UNRECOGNIZED";
})(GetVerificationMethodResponseMethod || (exports.GetVerificationMethodResponseMethod = GetVerificationMethodResponseMethod = {}));
function createBaseGetUserRequest() {
    return {};
}
exports.GetUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetUserRequest();
        return message;
    },
};
function createBaseGetUserResponse() {
    return { user: user_1.User.fromPartial({}) };
}
exports.GetUserResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? user_1.User.fromJSON(object.user) : user_1.User.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = user_1.User.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.GetUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? user_1.User.fromPartial(object.user)
            : user_1.User.fromPartial({});
        return message;
    },
};
function createBaseCreateUserRequest() {
    return {};
}
exports.CreateUserRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.CreateUserRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseCreateUserRequest();
        return message;
    },
};
function createBaseCreateUserResponse() {
    return { user: user_1.User.fromPartial({}) };
}
exports.CreateUserResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? user_1.User.fromJSON(object.user) : user_1.User.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = user_1.User.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.CreateUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCreateUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? user_1.User.fromPartial(object.user)
            : user_1.User.fromPartial({});
        return message;
    },
};
function createBaseUpdateUserResponse() {
    return { user: user_1.User.fromPartial({}) };
}
exports.UpdateUserResponse = {
    fromJSON(object) {
        const message = {
            user: isSet(object.user) ? user_1.User.fromJSON(object.user) : user_1.User.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.user !== undefined) {
            obj.user = user_1.User.toJSON(message.user);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateUserResponse();
        message.user = (object.user !== undefined && object.user !== null)
            ? user_1.User.fromPartial(object.user)
            : user_1.User.fromPartial({});
        return message;
    },
};
function createBaseUpdateShippingAddressRequest() {
    return { shippingAddress: undefined };
}
exports.UpdateShippingAddressRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.shippingAddress)) {
            message.shippingAddress = address_1.Address.fromJSON(object.shippingAddress);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.shippingAddress !== undefined) {
            obj.shippingAddress = address_1.Address.toJSON(message.shippingAddress);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateShippingAddressRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateShippingAddressRequest();
        message.shippingAddress =
            (object.shippingAddress !== undefined && object.shippingAddress !== null)
                ? address_1.Address.fromPartial(object.shippingAddress)
                : undefined;
        return message;
    },
};
function createBaseUpdateShippingAddressResponse() {
    return { updatedShippingAddress: undefined };
}
exports.UpdateShippingAddressResponse = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.updatedShippingAddress)) {
            message.updatedShippingAddress = address_1.Address.fromJSON(object.updatedShippingAddress);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.updatedShippingAddress !== undefined) {
            obj.updatedShippingAddress = address_1.Address.toJSON(message.updatedShippingAddress);
        }
        return obj;
    },
    create(base) {
        return exports.UpdateShippingAddressResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUpdateShippingAddressResponse();
        message.updatedShippingAddress =
            (object.updatedShippingAddress !== undefined && object.updatedShippingAddress !== null)
                ? address_1.Address.fromPartial(object.updatedShippingAddress)
                : undefined;
        return message;
    },
};
function createBaseSetProfilePictureRequest() {
    return { image: '' };
}
exports.SetProfilePictureRequest = {
    fromJSON(object) {
        const message = {
            image: isSet(object.image) ? globalThis.String(object.image) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.image !== '') {
            obj.image = message.image;
        }
        return obj;
    },
    create(base) {
        return exports.SetProfilePictureRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProfilePictureRequest();
        message.image = object.image ?? '';
        return message;
    },
};
function createBaseSetProfilePictureResponse() {
    return { pictureUrl: '' };
}
exports.SetProfilePictureResponse = {
    fromJSON(object) {
        const message = {
            pictureUrl: isSet(object.pictureUrl) ? globalThis.String(object.pictureUrl) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        return obj;
    },
    create(base) {
        return exports.SetProfilePictureResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseSetProfilePictureResponse();
        message.pictureUrl = object.pictureUrl ?? '';
        return message;
    },
};
function createBaseRemoveProfilePictureRequest() {
    return {};
}
exports.RemoveProfilePictureRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RemoveProfilePictureRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRemoveProfilePictureRequest();
        return message;
    },
};
function createBaseRemoveProfilePictureResponse() {
    return {};
}
exports.RemoveProfilePictureResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.RemoveProfilePictureResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseRemoveProfilePictureResponse();
        return message;
    },
};
function createBaseGetVerificationMethodRequest() {
    return {};
}
exports.GetVerificationMethodRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetVerificationMethodRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetVerificationMethodRequest();
        return message;
    },
};
function createBaseGetVerificationMethodResponse() {
    return { method: GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID };
}
exports.GetVerificationMethodResponse = {
    fromJSON(object) {
        const message = {
            method: isSet(object.method)
                ? getVerificationMethodResponseMethodFromJSON(object.method)
                : GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.method !== GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID) {
            obj.method = getVerificationMethodResponseMethodToJSON(message.method);
        }
        return obj;
    },
    create(base) {
        return exports.GetVerificationMethodResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetVerificationMethodResponse();
        message.method = object.method ??
            GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID;
        return message;
    },
};
function createBaseVerifyUserRequest() {
    return { dob: undefined, lastFourSsn: undefined, sessionLifetimeMs: '0', clientTimeMs: '0' };
}
exports.VerifyUserRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.dob)) {
            message.dob = globalThis.String(object.dob);
        }
        if (isSet(object.lastFourSsn)) {
            message.lastFourSsn = globalThis.String(object.lastFourSsn);
        }
        if (isSet(object.sessionLifetimeMs)) {
            message.sessionLifetimeMs = globalThis.String(object.sessionLifetimeMs);
        }
        if (isSet(object.clientTimeMs)) {
            message.clientTimeMs = globalThis.String(object.clientTimeMs);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.dob !== undefined) {
            obj.dob = message.dob;
        }
        if (message.lastFourSsn !== undefined) {
            obj.lastFourSsn = message.lastFourSsn;
        }
        if (message.sessionLifetimeMs !== undefined && message.sessionLifetimeMs !== '0') {
            obj.sessionLifetimeMs = message.sessionLifetimeMs;
        }
        if (message.clientTimeMs !== undefined && message.clientTimeMs !== '0') {
            obj.clientTimeMs = message.clientTimeMs;
        }
        return obj;
    },
    create(base) {
        return exports.VerifyUserRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerifyUserRequest();
        message.dob = object.dob ?? undefined;
        message.lastFourSsn = object.lastFourSsn ?? undefined;
        message.sessionLifetimeMs = object.sessionLifetimeMs ?? '0';
        message.clientTimeMs = object.clientTimeMs ?? '0';
        return message;
    },
};
function createBaseVerifyUserResponse() {
    return {
        userId: '',
        refreshToken: token_1.AuthToken.fromPartial({}),
        accessToken: token_1.AuthToken.fromPartial({}),
    };
}
exports.VerifyUserResponse = {
    fromJSON(object) {
        const message = {
            userId: isSet(object.userId) ? globalThis.String(object.userId) : '',
            refreshToken: isSet(object.refreshToken)
                ? token_1.AuthToken.fromJSON(object.refreshToken)
                : token_1.AuthToken.fromPartial({}),
            accessToken: isSet(object.accessToken)
                ? token_1.AuthToken.fromJSON(object.accessToken)
                : token_1.AuthToken.fromPartial({}),
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.userId !== '') {
            obj.userId = message.userId;
        }
        if (message.refreshToken !== undefined) {
            obj.refreshToken = token_1.AuthToken.toJSON(message.refreshToken);
        }
        if (message.accessToken !== undefined) {
            obj.accessToken = token_1.AuthToken.toJSON(message.accessToken);
        }
        return obj;
    },
    create(base) {
        return exports.VerifyUserResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseVerifyUserResponse();
        message.userId = object.userId ?? '';
        message.refreshToken = (object.refreshToken !== undefined && object.refreshToken !== null)
            ? token_1.AuthToken.fromPartial(object.refreshToken)
            : token_1.AuthToken.fromPartial({});
        message.accessToken = (object.accessToken !== undefined && object.accessToken !== null)
            ? token_1.AuthToken.fromPartial(object.accessToken)
            : token_1.AuthToken.fromPartial({});
        return message;
    },
};
function createBaseOnboardRequest() {
    return { performKyc: false, device: undefined, ecbsvSupported: false };
}
exports.OnboardRequest = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.performKyc)) {
            message.performKyc = globalThis.Boolean(object.performKyc);
        }
        if (isSet(object.device)) {
            message.device = device_token_1.DeviceToken.fromJSON(object.device);
        }
        if (isSet(object.ecbsvSupported)) {
            message.ecbsvSupported = globalThis.Boolean(object.ecbsvSupported);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.performKyc !== undefined && message.performKyc !== false) {
            obj.performKyc = message.performKyc;
        }
        if (message.device !== undefined) {
            obj.device = device_token_1.DeviceToken.toJSON(message.device);
        }
        if (message.ecbsvSupported !== undefined && message.ecbsvSupported !== false) {
            obj.ecbsvSupported = message.ecbsvSupported;
        }
        return obj;
    },
    create(base) {
        return exports.OnboardRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardRequest();
        message.performKyc = object.performKyc ?? false;
        message.device = (object.device !== undefined && object.device !== null)
            ? device_token_1.DeviceToken.fromPartial(object.device)
            : undefined;
        message.ecbsvSupported = object.ecbsvSupported ?? false;
        return message;
    },
};
function createBaseOnboardResponse() {
    return { kycStatus: kyc_1.KycStatus.INVALID, errors: [] };
}
exports.OnboardResponse = {
    fromJSON(object) {
        const message = {
            kycStatus: isSet(object.kycStatus) ? (0, kyc_1.kycStatusFromJSON)(object.kycStatus) : kyc_1.KycStatus.INVALID,
            errors: globalThis.Array.isArray(object?.errors)
                ? object.errors.map((e) => (0, kyc_error_1.kycErrorFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        if (message.errors?.length) {
            obj.errors = message.errors.map((e) => (0, kyc_error_1.kycErrorToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.OnboardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOnboardResponse();
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        message.errors = object.errors?.map((e) => e) || [];
        return message;
    },
};
function createBaseOffboardRequest() {
    return {};
}
exports.OffboardRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.OffboardRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseOffboardRequest();
        return message;
    },
};
function createBaseOffboardResponse() {
    return { kycStatus: kyc_1.KycStatus.INVALID };
}
exports.OffboardResponse = {
    fromJSON(object) {
        const message = {
            kycStatus: isSet(object.kycStatus) ? (0, kyc_1.kycStatusFromJSON)(object.kycStatus) : kyc_1.KycStatus.INVALID,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        return obj;
    },
    create(base) {
        return exports.OffboardResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseOffboardResponse();
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        return message;
    },
};
function createBaseGetProfilePicturesRequest() {
    return {};
}
exports.GetProfilePicturesRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetProfilePicturesRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetProfilePicturesRequest();
        return message;
    },
};
function createBaseGetProfilePicturesResponse() {
    return { pictureUrls: [] };
}
exports.GetProfilePicturesResponse = {
    fromJSON(object) {
        const message = {
            pictureUrls: globalThis.Array.isArray(object?.pictureUrls)
                ? object.pictureUrls.map((e) => globalThis.String(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.pictureUrls?.length) {
            obj.pictureUrls = message.pictureUrls;
        }
        return obj;
    },
    create(base) {
        return exports.GetProfilePicturesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetProfilePicturesResponse();
        message.pictureUrls = object.pictureUrls?.map((e) => e) || [];
        return message;
    },
};
function createBaseGetQuotasRequest() {
    return {};
}
exports.GetQuotasRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetQuotasRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetQuotasRequest();
        return message;
    },
};
function createBaseGetQuotasResponse() {
    return { quotas: [] };
}
exports.GetQuotasResponse = {
    fromJSON(object) {
        const message = {
            quotas: globalThis.Array.isArray(object?.quotas)
                ? object.quotas.map((e) => quota_state_1.QuotaState.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quotas?.length) {
            obj.quotas = message.quotas.map((e) => quota_state_1.QuotaState.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetQuotasResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetQuotasResponse();
        message.quotas = object.quotas?.map((e) => quota_state_1.QuotaState.fromPartial(e)) || [];
        return message;
    },
};
function getVerificationMethodResponseMethodFromJSON(object) {
    switch (object) {
        case 0:
        case 'VERIFICATION_METHOD_INVALID':
            return GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID;
        case 1:
        case 'USE_DOB':
            return GetVerificationMethodResponseMethod.USE_DOB;
        case 2:
        case 'USE_SSN':
            return GetVerificationMethodResponseMethod.USE_SSN;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return GetVerificationMethodResponseMethod.UNRECOGNIZED;
    }
}
exports.getVerificationMethodResponseMethodFromJSON = getVerificationMethodResponseMethodFromJSON;
function getVerificationMethodResponseMethodToJSON(object) {
    switch (object) {
        case GetVerificationMethodResponseMethod.VERIFICATION_METHOD_INVALID:
            return 'VERIFICATION_METHOD_INVALID';
        case GetVerificationMethodResponseMethod.USE_DOB:
            return 'USE_DOB';
        case GetVerificationMethodResponseMethod.USE_SSN:
            return 'USE_SSN';
        case GetVerificationMethodResponseMethod.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.getVerificationMethodResponseMethodToJSON = getVerificationMethodResponseMethodToJSON;
/**
 * User Service API.
 *
 * Allows caller to create/update STEP users and onboard them with the bank.
 * This is a public facing API, so the caller is authenticated before performing
 * any of the actions.
 */
class UserServiceClient {
    rpc;
    name = 'com.step.user.proto.UserService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/user';
    methods = [{
            name: 'Get',
            requestType: exports.GetUserRequest,
            responseType: exports.GetUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'Create',
            requestType: exports.CreateUserRequest,
            responseType: exports.CreateUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Update',
            requestType: user_update_request_1.UpdateUserRequest,
            responseType: exports.UpdateUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'UpdateShippingAddress',
            requestType: exports.UpdateShippingAddressRequest,
            responseType: exports.UpdateShippingAddressResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'SetProfilePicture',
            requestType: exports.SetProfilePictureRequest,
            responseType: exports.SetProfilePictureResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'RemoveProfilePicture',
            requestType: exports.RemoveProfilePictureRequest,
            responseType: exports.RemoveProfilePictureResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetVerificationMethod',
            requestType: exports.GetVerificationMethodRequest,
            responseType: exports.GetVerificationMethodResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
        }, {
            name: 'Verify',
            requestType: exports.VerifyUserRequest,
            responseType: exports.VerifyUserResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.RESTRICTED },
        }, {
            name: 'Onboard',
            requestType: exports.OnboardRequest,
            responseType: exports.OnboardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.STRONG },
        }, {
            name: 'Offboard',
            requestType: exports.OffboardRequest,
            responseType: exports.OffboardResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetProfilePictures',
            requestType: exports.GetProfilePicturesRequest,
            responseType: exports.GetProfilePicturesResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }, {
            name: 'GetQuotas',
            requestType: exports.GetQuotasRequest,
            responseType: exports.GetQuotasResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Looks up an existing user.
     */
    get(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Creates a new user account.
     */
    create(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates an existing user account. If the user has been KYCed prior to
     * making this call, then the user's KYC status is reset.
     */
    update(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Updates the authenticated user's shipping address. Similar to Update but
     * scoped to the shipping address field because of the audience.
     */
    updateShippingAddress(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[3],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Set the profile picture for the user to the supplied base64 encoded
     * image. The public url of the uploaded image is returned.
     */
    setProfilePicture(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[4],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Remove the profile picture for the user
     */
    removeProfilePicture(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[5],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Fetches user verification method that must be used for account recovery.
     * The method depends on the account state (e.g. do we have the user's SSN,
     * etc).
     */
    getVerificationMethod(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[6],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Verifies account ownership and re-enables user account. This is used
     * post account recovery (that puts account into disabled state).
     */
    verify(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[7],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Onboards the user with the underlying bank. Typically involves going
     * through KYC flow.
     */
    onboard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[8],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Offboards the user. Used for testing to reset onboarding flow.
     */
    offboard(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[9],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    getProfilePictures(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[10],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get all USER and FAMILY quotas that are visible to the user.
     */
    getQuotas(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[11],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.UserServiceClient = UserServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=user-service.js.map